import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const OakParkPage = () => <LocationTemplate suburbName="Oak Park" suburbSlug="oak-park" />;

export default OakParkPage;
